// @flow

import React, { Fragment } from 'react';
import Toggler from '../../components/UI/Toggler';
import { Collapse } from 'reactstrap';
import isEmpty from 'lodash/isEmpty';

type SummaryProps = {
  title: string,
  description: string,
};

type DescriptionProps = {
  start_place: string,
  end_place: string,
  summary: null | Array<SummaryProps>,
};

type Props = {
  desc: Array<DescriptionProps>,
};

const TrailDescription = ({ desc }: Props) => (
  <div className="white-panel">
    <div className="row">
      <div className="col-12 day-summery">
        <div className="day-info clearfix">
          <h2>Trail Description</h2>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-12">{desc.map(v => renderDescription(v))}</div>
    </div>
  </div>
);

const renderDescription = ({ summary, start_place, end_place }: DescriptionProps) => (
  <Toggler key={`${start_place}${end_place}`}>
    {({ on, toggle }) => (
      <div className="white-panel breakdown">
        <h3 className="brekdown-title" onClick={toggle} style={{ cursor: 'pointer' }}>
          <span>
            {start_place} to {end_place}
          </span>
          <span className="brekdown-price" style={{ color: '#000' }}>
            <i className={`icon icon-hg-chev-${on ? 'up' : 'down'}`} />
          </span>
        </h3>
        {!isEmpty(summary) && (
          <Collapse isOpen={on}>{summary.map(v => renderSummary(v))}</Collapse>
        )}
      </div>
    )}
  </Toggler>
);

const renderSummary = ({ title, description }: SummaryProps) => (
  <Toggler initialOn={true} key={title}>
    {({ on, toggle }) => (
      <Fragment>
        <p
          style={{
            cursor: 'pointer',
            marginTop: '5px',
            marginBottom: '5px',
            fontSize: '13px',
          }}
          onClick={toggle}
        >
          <strong>{title.toUpperCase()}</strong>
        </p>
        <Collapse isOpen={on} className="inside-col">
          {description}
        </Collapse>
      </Fragment>
    )}
  </Toggler>
);

export default TrailDescription;



// WEBPACK FOOTER //
// ./src/screens/Trek/TrailDescription.js